import React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

import styles from "./Loader.module.scss";

const Loader = ({ variant = "fullscreen" }) => {
  if (variant === "inline") {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={2}>
        <CircularProgress disableShrink size={32} />
      </Box>
    );
  }

  return (
    <CircularProgress disableShrink className={styles.loadingContainer} />
  );
};

Loader.propTypes = {
  variant: PropTypes.oneOf(["fullscreen", "inline"]),
};

export default Loader;
